import { SvgIconInfo } from './mat-icon-registry-init.service';

export const IconSet: SvgIconInfo[] = [
  {
    iconName: 'charging-card',
    iconFilePath: 'icon-charging-card.svg'
  },
  {
    iconName: 'charging-cards',
    iconFilePath: 'icon-charging-cards.svg'
  },
  {
    iconName: 'charging-card-blocked',
    iconFilePath: 'icon-charging-card-blocked.svg'
  },
  {
    iconName: 'no-public-tariff',
    iconFilePath: 'icon-empty-state.svg'
  },
  {
    iconName: 'card-tariff-extraordinary-termination',
    iconFilePath: 'icon-empty-state.svg'
  },
  {
    iconName: 'check',
    iconFilePath: 'icon-check.svg'
  },
  {
    iconName: 'invoice',
    iconFilePath: 'icon-invoice.svg'
  },
  {
    iconName: 'mlogin',
    iconFilePath: 'icon-mlogin.svg'
  },
  {
    iconName: 'edit',
    iconFilePath: 'icon-edit-pen.svg'
  },
  {
    iconName: 'edit-v2',
    iconFilePath: 'icon-edit-pen-v2.svg'
  },
  {
    iconName: 'icon-completed',
    iconFilePath: 'icon-completed.svg'
  },
  {
    iconName: 'charging_processes_empty_state',
    iconFilePath: 'icon-empty-state.svg'
  },
  {
    iconName: 'filter_active_gray',
    iconFilePath: 'icon-filter-active-2.svg'
  },
  {
    iconName: 'filter_active_white',
    iconFilePath: 'icon-filter-active.svg'
  },
  {
    iconName: 'contracts_empty_state',
    iconFilePath: 'icon-empty-state.svg'
  },
  {
    iconName: 'public_charging_current_contract',
    iconFilePath: 'm-ladestrom-oeffentlich-vertragt.svg'
  },
  {
    iconName: 'tariff-renewal-done',
    iconFilePath: 'icon-tariff-renewal-done.svg'
  },
  {
    iconName: 'mail',
    iconFilePath: 'icon-mail.svg'
  },
  {
    iconName: 'link',
    iconFilePath: 'icon-link.svg'
  },
  {
    iconName: 'link_inactive',
    iconFilePath: 'icon-link-inactive.svg'
  },
  {
    iconName: 'phone',
    iconFilePath: 'icon-phone.svg'
  },
  {
    iconName: 'icon-support',
    iconFilePath: 'icon-support.svg'
  },
  {
    iconName: 'no_invoices',
    iconFilePath: 'icon-empty-state.svg'
  },
  {
    iconName: 'placeholder',
    iconFilePath: 'placeholder.svg'
  },
  {
    iconName: 'info',
    iconFilePath: 'icon-info-outline.svg'
  },
  {
    iconName: 'error',
    iconFilePath: 'icon-error.svg'
  },
  {
    iconName: 'card-activation',
    iconFilePath: 'mladen-card-activation.svg'
  },
  {
    iconName: 'card-start',
    iconFilePath: 'mladen-card-start.svg'
  },
  {
    iconName: 'station',
    iconFilePath: 'icon-ladestationen.svg'
  },
  {
    iconName: 'charging-processes',
    iconFilePath: 'icon-charging-processes.svg'
  },
  {
    iconName: 'charging',
    iconFilePath: 'icon-charging.svg'
  },
  {
    iconName: 'filter',
    iconFilePath: 'icon-filter.svg'
  },
  {
    iconName: 'date-picker',
    iconFilePath: 'icon-date-picker.svg'
  },
  {
    iconName: 'edit-chalk',
    iconFilePath: 'icon-edit-chalk.svg'
  },
  {
    iconName: 'account-connection-completed',
    iconFilePath: 'icon-account-connection-completed.svg'
  },
  {
    iconName: 'station-connection-completed',
    iconFilePath: 'icon-station-connection-completed.svg'
  },
  {
    iconName: 'station-connection',
    iconFilePath: 'icon-charging-station-connection.svg'
  },
  {
    iconName: 'oeffentliche-ladestation',
    iconFilePath: 'oeffentliche-ladestation.svg'
  },
  {
    iconName: 'private-ladestation',
    iconFilePath: 'private-ladestation.svg'
  },
  {
    iconName: 'status-available',
    iconFilePath: 'icon-status-available.svg'
  },
  {
    iconName: 'status-occupied',
    iconFilePath: 'icon-status-occupied.svg'
  },
  {
    iconName: 'status-unavailable',
    iconFilePath: 'icon-status-unavailable.svg'
  },
  {
    iconName: 'status-unknown',
    iconFilePath: 'icon-status-unknown.svg'
  },
  {
    iconName: 'status-private-available',
    iconFilePath: 'icon-status-private-available.svg'
  },
  {
    iconName: 'status-private-unavailable',
    iconFilePath: 'icon-status-private-unavailable.svg'
  },
  {
    iconName: 'status-private-unknown',
    iconFilePath: 'icon-status-private-unknown.svg'
  },
  {
    iconName: 'status-private-charging',
    iconFilePath: 'icon-status-private-charging.svg'
  },
  {
    iconName: 'map',
    iconFilePath: 'icon-map.svg'
  },
  {
    iconName: 'heart',
    iconFilePath: 'icon-heart.svg'
  },
  {
    iconName: 'heart-filled',
    iconFilePath: 'icon-heart-filled.svg'
  },
  {
    iconName: 'available',
    iconFilePath: 'icon-available.svg'
  },
  {
    iconName: 'plug-ccs',
    iconFilePath: 'icon-plug-ccs.svg'
  },
  {
    iconName: 'plug-typ2',
    iconFilePath: 'icon-plug-typ2.svg'
  },
  {
    iconName: 'plug-chademo',
    iconFilePath: 'icon-plug-chademo.svg'
  },
  {
    iconName: 'unknown',
    iconFilePath: 'icon-unknown.svg'
  },
  {
    iconName: 'geolocation-denied',
    iconFilePath: 'icon-geolocation-denied.svg'
  },
  {
    iconName: 'cancel',
    iconFilePath: 'icon-cancel.svg'
  },
  {
    iconName: 'card-tariff-termination',
    iconFilePath: 'icon-charging-card-tariff-termination.svg'
  }
];
